import styled from 'styled-components';

export const UniversalSchedulerStyles = styled.div`
  padding: 0;

  ${props => props.theme.media.md} {
    padding: 2rem 0;
  }

  .sub-message {
    text-align: center;
  }
`;
